import { Pipe, PipeTransform } from '@angular/core';
import { TekstResourceService } from '../services/tekstresource/tekstresource.service';

/** This pipe can be used as <p>{{ ["Vejledning","8PageHeadLine" | tekstresource }}</p>
 * or if the tekstresource contains HTML that needs to be parsed:
 * <div [innerHTML]="['SigneringIndex','SignaturLead' | tekstresource"></div>
 */
@Pipe({ name: 'tekstresource' })
export class TekstResourcePipe implements PipeTransform {
  constructor(private tekstResourceService: TekstResourceService) {}

  transform(value: string, params?: { [s: string]: any }): string {
    const resourceKey = value;
    let tekstresource = this.tekstResourceService.getTekstResource(resourceKey);

    // Allow for parameters in web texts
    if (params) {
      tekstresource = this.merge(tekstresource, params);
    }
    return tekstresource;
  }

  /** Merges the input text with the data supplied. Data must be an object of keys and values
   *  Only objects with one level of values is supported
   *  Example:
   *  - text: ´Hi {name}. How is your day´
   *  - params: { name: 'John Doe' }
   *  - result: Hi John Doe. How is your day
   */
  private merge(text: string, params: { [s: string]: any }) {
    let output = text;
    for (const prop in params) {
      if (prop) {
        const pattern = `\{${prop}\}`;
        const regex = new RegExp(pattern, 'g');
        const replacement = params[prop];
        output = output.replace(regex, replacement);
      }
    }
    return output;
  }
}
